import { useQuery } from '@tanstack/react-query';

import { getSystemLocationCourtsController } from '@/interface-adapters/controllers/system-locations/get-system-location-courts.controller';
import { systemLocationKeys } from '@/hooks/system-locations/systemLocationKeys';

export const useSystemLocationCourtsQuery = ({
	moduleFor,
	moduleUuid,
	locationId
}: {
	moduleFor: string;
	moduleUuid: string;
	locationId: string;
}) => {
	return useQuery({
		queryKey: systemLocationKeys.systemLocationCourts(moduleFor, moduleUuid, locationId),
		queryFn: () => getSystemLocationCourtsController(moduleFor, moduleUuid, locationId)
	});
};
